/**
 * Single source of truth for the running client bundle version.
 *
 * Format: "<semver>+<buildId>"  e.g. "2.2.0+1780900000000"
 * - semver: from package.json via VITE_APP_VERSION
 * - buildId: epoch ms set at build time (vite.config.ts)
 *
 * All code paths that need the "current running version" MUST import from
 * here. Do not read VITE_APP_VERSION anywhere else.
 */

export const RUNNING_VERSION =
  (import.meta.env.VITE_APP_VERSION as string | undefined) || "dev";

export function getRunningVersion(): string {
  return RUNNING_VERSION;
}

export function isDevBuild(): boolean {
  return RUNNING_VERSION === "dev" || Boolean(import.meta.env.DEV);
}

/** Stable per-tab id — used in telemetry to track reload loops. */
export const TAB_ID =
  Math.random().toString(36).slice(2, 10) + Date.now().toString(36);
